import { Heading } from '@adobe/react-spectrum';
import p from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import AppCard from '../../../components/AppCard';

const AppCardErrorText = styled.p`
  margin: 0;
  opacity: 0.5;
  font-size: 13px;

  & code {
    font-size: 13px;
  }
`;

const AppCardError = (props) => {
  const { appId } = props;
  return (
    <AppCard cardWidth="100%">
      <AppCard.Header loading disableSkeletonAnimation />
      <AppCard.Body>
        <Heading level={4} margin="0">
          We're unable to show this app due to data corruption.
        </Heading>
        <AppCardErrorText>
          An error occured while trying to display the details of this app. Please let us know that there's an issue
          with app <code> {appId}</code>
        </AppCardErrorText>
      </AppCard.Body>
      <AppCard.Footer loading disableSkeletonAnimation />
    </AppCard>
  );
};

AppCardError.propTypes = {
  appId: p.string,
};

AppCardError.defaultProps = {
  appId: 'undefined',
};

export default AppCardError;
